/* eslint no-undef: 0 */
import { ENGLISH_LANG } from 'configs/constants';
import i18n from '../../i18n';

export const getText = (label) => {
    if (i18n.t &&  (!i18n.t(label) || i18n.t(label)?.length === 0)) {
        return i18n.t(label, { lng: ENGLISH_LANG });
    } else if(i18n.t) {
        return i18n.t(label);
    } else {
        return label;
    }
};
